var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-0 pa-0",attrs:{"fluid":""}},[_c('q-agency-building-submenu'),_c('v-row',{staticClass:"mx-7 q-sticky-buffer",attrs:{"wrap":""}},[_c('v-card',{staticClass:"pa-6 text-center"},[_c('q-configure-affiliate-widget')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }